// ============================================
// POLÍTICA DO FEW-SHOT MECR-RAG — fonte única (B351 passo 5b, AI_153)
// ============================================
// O circuito MECR-RAG reusa análises APROVADAS de outros pacientes como exemplo
// de raciocínio no prompt do paciente atual (`buscarAnalisesAprovadas`). Decidir
// QUEM pode entrar nesse circuito é uma regra de PRIVACIDADE, não um detalhe de
// implementação — por isso ela vive aqui, nomeada e testada, em vez de um `if`
// repetido no hook e na tela (onde divergiria em silêncio).
//
// A regra vale nas DUAS pontas, e as duas importam:
//   - na LEITURA  (`useIAAnalise.buscarAnalisesAprovadas`) — não injeta exemplo;
//   - na GRAVAÇÃO (`AbaAnaliseIA`, calibração) — não marca `aprovada: true`.
// Só a leitura não bastaria: o histórico pode já conter documentos aprovados.

import { ehDoadorFigado } from "../../../shared/utils/modalidadeAtendimento";

/**
 * A modalidade pode participar do few-shot MECR (ler e virar exemplo)?
 *
 * ⛔ DOADOR DE FÍGADO: NÃO. Decisão de Leonardo (05/09/2026), a reabrir com o
 * advogado. Dois motivos:
 *
 * 1. **Dado de terceiro.** A análise do doador cita o CONJUNTO MÍNIMO DO
 *    RECEPTOR (peso, MELD com data, diagnóstico). `minimizarExemploMECR` redige
 *    datas, nomes e identificadores, mas PRESERVA labs e números de propósito —
 *    é o que dá valor pedagógico ao exemplo. Reusar a análise do doador X no
 *    prompt do doador Y levaria dados de um RECEPTOR-TERCEIRO para outro
 *    prontuário. O filtro por `tipoAtendimentoAprovado` separa as modalidades,
 *    mas não resolve isto.
 *
 * 2. **Contaminação do enquadramento.** Enquanto a modalidade não tiver análise
 *    própria, o texto do doador é gerado pelo pipeline do RECEPTOR (system
 *    prompt que ORDENA bloco de situação especial e MELD ajustado). Uma
 *    aprovação congelaria esse enquadramento como exemplo-ouro carimbado
 *    `doador_figado`, propagando-o a todos os doadores futuros — dano
 *    persistente em Firestore, não um texto ruim na tela.
 *
 * As demais modalidades seguem inalteradas (comportamento anterior ao B351).
 */
export function modalidadeUsaFewShotMECR(tipoAtendimento?: string | null): boolean {
  return !ehDoadorFigado(tipoAtendimento);
}
